import { CANVAS_EMBED_STRATEGY, DEFAULT_PRESENTATION_RENDERERS_FOR_ASSET_TYPE_MAP, DEFAULT_THUMBNAIL_PRESENTATION_RENDERERS_FOR_ASSET_TYPE_MAP, LAYOUT, PAGE_PADDING, PDF_PRELOAD_STRATEGY, PDF_RENDERER, PDF_RENDER_STRATEGY, VIEW_PADDING, DEFAULT_THREE_JS_DEPS, DEFAULT_TRANSLATIONS } from '../constants/Constants';
import { browser } from '../helpers/BrowserHelper';
import { PdfViewerLayoutType } from './PdfViewer/+types/pdf-viewer-layout.type';
import { ThemeType } from '../types/theme.type';
export class Config {
    constructor(props = {}) {
        this.THEME = ThemeType.LIGHT;
        this.THEME_FULLSCREEN = ThemeType.DARK;
        this.DEBUG = false;
        this.TINT_COLOR = '#00A67C';
        this.THREE_JS_DEPS = DEFAULT_THREE_JS_DEPS;
        this.DEFAULT_THUMB_BASE_PATH = '/share/static/images/default';
        this.SHOWPAD_JS_PATH = null;
        this.showpadUser = null;
        this.thumbnailViewer = true;
        this.container = null;
        this.thumbnailContainer = null;
        this.navigationContainer = null;
        this.rootAssetViewer = null;
        this.CAN_CREATE_ANNOTATIONS = false;
        this.VIEWER_LAYOUT = LAYOUT.VERTICAL;
        this.THUMBNAIL_VIEWER_LAYOUT = LAYOUT.VERTICAL_THUMBNAILS;
        this.PDF_VIEWER_LAYOUT = PdfViewerLayoutType.SinglePage;
        this.PDF_VIEWER_TOOLBAR_UNAVAILABLE_ACTIONS = undefined; // Exposed so coach viewer can hide switch layout
        this.VIEWS_TO_PRELOAD = 8;
        this.VIEWS_TO_PRELOAD_MOBILE = 5;
        this.BATCH_DESTROY_VIEWS_COUNT = 10;
        this.VIEWPORT_UPDATE_DEBOUNCE_TIMEOUT = 60;
        this.IDLE_DEBOUNCE_TIMEOUT = 400;
        this.RESIZE_DEBOUNCE_TIMEOUT = 150;
        this.ACTION_BAR_HIDE_TIMEOUT = 2500;
        this.SHOW_VIEW_LOADER_TIMEOUT = 500;
        this.IS_SLAVE_ASSET_VIEWER = false; // let the parent viewer handle the view rendering
        this.VIEW_BORDER = 1;
        this.VIEW_PADDING_TOP = VIEW_PADDING;
        this.VIEW_PADDING_BOTTOM = VIEW_PADDING;
        this.VIEW_PADDING_LEFT = browser.phone ? 0 : VIEW_PADDING;
        this.VIEW_PADDING_RIGHT = browser.phone ? 0 : VIEW_PADDING;
        this.VIEW_BORDER_BOTTOM = 1;
        this.THUMBNAIL_VIEW_BORDER = 1;
        this.THUMBNAIL_VIEW_BORDER_BOTTOM = 1;
        this.THUMBNAIL_VIEW_PADDING_TOP = 12;
        this.THUMBNAIL_VIEW_PADDING_BOTTOM = 20;
        this.THUMBNAIL_VIEW_PADDING_LEFT = 50; // Make sure when adjusting this, there's room for the 'Select Pages Checkboxes'
        this.THUMBNAIL_VIEW_PADDING_RIGHT = 50; // Make sure when adjusting this, there's room for the 'Select Pages Checkboxes'
        this.PAGE_PADDING_BOTTOM = PAGE_PADDING;
        this.PAGE_PADDING_TOP = 0;
        this.MAX_CONTENT_WIDTH = 896;
        this.MAX_CONTENT_WIDTH_PORTRAIT_DOCUMENTS = 896;
        this.MAX_CONTENT_WIDTH_PAGES = undefined;
        this.MAX_ZOOM_SCALE = 2;
        this.MIN_ZOOM_SCALE = 0.5;
        this.LANDSCAPE_FIT_WIDTH_BREAKPOINT_WIDTH = 600;
        this.LANDSCAPE_FIT_WIDTH_BREAKPOINT_HEIGHT = 600;
        this.TRANSITIONS_ENABLED = true;
        this.SHOW_VIEW_LOADER = true;
        this.canZoom = true;
        this.ENABLE_LINKS = true;
        this.CANVAS_EMBED_STRATEGY = CANVAS_EMBED_STRATEGY.CANVAS;
        this.PRESENTATION_RENDERERS_FOR_ASSET_TYPE_MAP = DEFAULT_PRESENTATION_RENDERERS_FOR_ASSET_TYPE_MAP;
        this.THUMBNAIL_PRESENTATION_RENDERERS_FOR_ASSET_TYPE_MAP = DEFAULT_THUMBNAIL_PRESENTATION_RENDERERS_FOR_ASSET_TYPE_MAP;
        // should be set in the parent Project, the parent project can choose to preload these resources
        this.getPdfJs = () => Promise.reject("getPdfJs wasn't configured");
        this.getPdfJsWorker = () => Promise.reject("getPdfJsWorker wasn't configured");
        this.refreshToken = undefined;
        this.confirmKeyboardNavigation = () => true;
        this.confirmNavigationToOtherAssetViewerItem = () => Promise.resolve(true);
        this.DOCUMENT_ASSET_VIEWER_CONFIG = null;
        this.PORTRAIT_DOCUMENT_ASSET_VIEWER_CONFIG = null;
        this.PDF_RENDERER = PDF_RENDERER.CANVAS;
        this.PDF_RENDER_STRATEGY = PDF_RENDER_STRATEGY.LOW_PREVIEW_PDFJS;
        this.PDF_PRELOAD_STRATEGY = PDF_PRELOAD_STRATEGY.FULL;
        this.PDFJS_ENHANCE_TEXT_SELECTION = false;
        this.PDFJS_RENDER_INTERACTIVE_FORMS = false;
        this.PDFJS_MAX_IMAGE_SIZE_TO_STORE = undefined;
        this.RENDER_VISIBLE_VIEWS_CONCURRENTLY = true;
        this.PDFJS_RANGE_CHUNK_SIZE = undefined; // will use PDFJS' default value: DEFAULT_RANGE_CHUNK_SIZE = 65536; // 2^16 = 65536
        this.PDFJS_MAX_RANGE_CHUNK_SIZE = 4000000;
        this.PDFJS_MIN_RANGE_CHUNK_SIZE = 256000;
        this.PDFJS_MAX_CANVAS_PIXELS = 3000 * 3000;
        this.PDFJS_PINCH_ZOOM_ENABLED = false;
        this.THREEJS_USE_PREVIEW_DIMENSIONS = false;
        this.THREEJS_VIEW_FULLSCREEN = false;
        this.THREEJS_SCENE_BACKGROUND_COLOR = '#D9D9D9';
        this.THREEJS_CROSS_ORIGIN = 'use-credentials';
        this.THREEJS_HELP_CENTRE_LEARNMORE_URL = 'https://help.showpad.com/hc/en-us/articles/360003822554#learnmore';
        this.VIDEO_POSTER_IMAGE_ENABLED = false;
        this.IFRAME_ALLOW = 'camera *; microphone *;';
        this.ENABLE_GROUPED_PAGE_SELECTION = false;
        this.SCORM_API_AVAILABLE = false;
        this.TRACK_HTML_PAGE_LOCATION_ENABLED = false;
        this.DOCUMENT_FORCE_PORTRAIT_VIEWER = false;
        this.TRANSLATIONS = DEFAULT_TRANSLATIONS;
        this.IS_WINDOWS_DESKTOP_APP = false;
        /**
         * VIEWS_TO_PRELOAD_PER_ASSET_TYPE: {
         *   [ASSET_TYPE.VIDEO]: 0 // -> do not preload any videos before and after current visible views
         *   [ASSET_TYPE.PAGE]: 1 // -> only preload one page before and after current visible views
         * }
         *
         * This is used to filter out views based on asset types.
         * The filtering occurs once on the views before the visible views and once on the views after the visible views.
         */
        this.VIEWS_TO_PRELOAD_PER_ASSET_TYPE = {};
        this.pdfViewerSearchConfig = null;
        this.pdfViewerPendoConfig = null;
        this.SWIPE_ENABLED = false;
        Object.keys(props).forEach(key => {
            if (this.hasOwnProperty(key)) {
                this[key] = props[key];
            }
            else {
                console.warn(`Asset viewer: unknown configuration param passed to Config: "${key}"`);
            }
        });
    }
}
//# sourceMappingURL=Config.js.map